import React from "react";

const URGENCY_STYLES = {
  low: "bg-sky-100 border-sky-400 text-sky-700",
  normal: "bg-green-100 border-green-500 text-green-800",
  high: "bg-amber-100 border-amber-500 text-amber-700",
  critical: "bg-red-100 border-red-400 text-red-700",
};

const DEFAULT_URGENCY_CLASSES = "bg-gray-100 border-gray-300 text-gray-700";

const getUrgencyClasses = (urgency) => {
  if (!urgency) {
    return null;
  }

  return URGENCY_STYLES[String(urgency).toLowerCase()] || null;
};

const NotificationBanner = ({ notification, onDismiss }) => {
  const urgencyClasses = getUrgencyClasses(notification.urgency);
  const bannerClasses = urgencyClasses || DEFAULT_URGENCY_CLASSES;

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss(notification.id);
    }
  };

  const isCritical = String(notification.urgency).toLowerCase() === "critical";

  return (
    <div
      role={isCritical ? "alert" : "status"}
      className={`${bannerClasses} py-3 px-4 flex items-center justify-between shadow-md relative border`}
    >
      <div className="flex-1">
        {notification.title && (
          <div className="font-bold text-sm mb-1">{notification.title}</div>
        )}
        <div className="text-sm">{notification.notification_message}</div>
      </div>

      <button
        type="button"
        onClick={handleDismiss}
        className="ml-4 hover:opacity-70 flex-shrink-0 p-1 transition-opacity"
        aria-label="Dismiss notification"
      >
        <svg
          aria-hidden="true"
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};

export default NotificationBanner;
